import React, { useState } from "react";
import {
  disableAnalytics,
  getAnalyticsConsent,
  initializeAnalytics,
  setAnalyticsConsent,
} from "../analytics";

const CookieConsent = () => {
  const [isOpen, setIsOpen] = useState(!getAnalyticsConsent());

  const accept = () => {
    setAnalyticsConsent("granted");
    setIsOpen(false);
    initializeAnalytics();
  };

  const reject = () => {
    setAnalyticsConsent("denied");
    disableAnalytics();
    setIsOpen(false);
  };

  if (!isOpen) {
    return (
      <button
        className="cookie-settings-button"
        type="button"
        onClick={() => setIsOpen(true)}
      >
        Cookie settings
      </button>
    );
  }

  return (
    <section className="cookie-consent" aria-label="Analytics cookie settings">
      <div>
        <h2>Analytics cookies</h2>
        <p>
          UltimateFantasy uses optional Google Analytics cookies to understand how
          the site is used. No analytics are loaded unless you accept.
        </p>
      </div>
      <div className="cookie-consent-actions">
        <button type="button" className="cookie-reject" onClick={reject}>
          Reject
        </button>
        <button type="button" className="cookie-accept" onClick={accept}>
          Accept
        </button>
      </div>
    </section>
  );
};

export default CookieConsent;
